// // src/pages/Dashboard/QuickQuote/components/ThirdPage.jsx
// import React, { useState, useEffect } from 'react';
// import * as XLSX from 'xlsx';
// import styles from './ThirdPage.module.css';

// const ThirdPage = ({ selectedData, quantities, onBack }) => {
//   const [itemsWithDisplayNumbers, setItemsWithDisplayNumbers] = useState([]);

//   useEffect(() => {
//     // Add sequential display numbers to selected items
//     const dataWithDisplayNumbers = selectedData.map((item, index) => ({
//       ...item,
//       displaySLNO: index + 1
//     }));
//     setItemsWithDisplayNumbers(dataWithDisplayNumbers);
//   }, [selectedData]);

//   const exportToExcel = () => {
//     // Prepare data rows
//     const headers = [
//       'S.No', 'CAS', 'Description', 'Cat_No', 'PKZ', 'UOM', 'Customer PKZ',
//       'Stock In India', 'China Stock', 'HAZ / Non HAZ', 'Price',
//       'Discount', 'Final Price', 'Reference', 'Qty', 'Value'
//     ];

//     const rows = itemsWithDisplayNumbers.map(item => {
//       const pkz = item.packSize?.quantity ? item.packSize.quantity : '-';

//       return [
//         item.displaySLNO,
//         item.cas || '',
//         item.description || '',
//         item.catNo || '',
//         item.quantity || '',
//         item.uom || '',
//         pkz,
//         item.stockInIndia || '',
//         item.chinaStock || '',
//         item.hazStatus || '',
//         item.price || '',
//         item.discount || '',
//         parseFloat(item.finalPrice || 0).toFixed(2),
//         item.refNo || '',
//         quantities[item.slno] || 0,
//         parseFloat(item.value || 0).toFixed(2)
//       ];
//     });

//     // Create worksheet
//     const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    
//     // Define the range of cells in the worksheet
//     const range = XLSX.utils.decode_range(worksheet['!ref']);
    
//     // Apply styling to all cells
//     for (let R = range.s.r; R <= range.e.r; R++) {
//       for (let C = range.s.c; C <= range.e.c; C++) {
//         const cellAddress = { c: C, r: R };
//         const cellRef = XLSX.utils.encode_cell(cellAddress);
        
//         if (!worksheet[cellRef]) {
//           worksheet[cellRef] = { t: 's', v: '' };
//         }
        
//         worksheet[cellRef].s = {
//           alignment: { 
//             horizontal: "center", 
//             vertical: "center",
//             wrapText: true
//           },
//           border: {
//             top: { style: "thin", color: { rgb: "000000" } },
//             bottom: { style: "thin", color: { rgb: "000000" } },
//             left: { style: "thin", color: { rgb: "000000" } },
//             right: { style: "thin", color: { rgb: "000000" } }
//           },
//           font: {
//             sz: R === 0 ? 12 : 11,
//             bold: R === 0
//           }
//         };
//       }
//     }

//     // Set column widths
//     const colWidths = [
//       { wch: 6 },  // S.No
//       { wch: 12 }, // CAS
//       { wch: 40 }, // Description
//       { wch: 12 }, // Cat_No
//       { wch: 10 }, // PKZ
//       { wch: 8 },  // UOM
//       { wch: 12 }, // Customer PKZ
//       { wch: 15 }, // Stock In India
//       { wch: 12 }, // China Stock
//       { wch: 15 }, // HAZ / Non HAZ
//       { wch: 10 }, // Price
//       { wch: 10 }, // Discount
//       { wch: 12 }, // Final Price
//       { wch: 12 }, // Reference
//       { wch: 6 },  // Qty
//       { wch: 12 }  // Value
//     ];
    
//     worksheet['!cols'] = colWidths;

//     // Create workbook
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Items");
    
//     // Export the file
//     const timestamp = new Date().toISOString().slice(0, 10);
//     XLSX.writeFile(workbook, `quick_quote_${timestamp}.xlsx`);
//   };

//   const totalValue = itemsWithDisplayNumbers.reduce((sum, item) => sum + item.value, 0);
//   const pkzMatches = itemsWithDisplayNumbers.filter(item => item.packSizeMatches).length;

//   return (
//     <div className={styles.pageContainer}>
//       <div className={styles.card}>
//         {/* Header */}
//         <div className={styles.header}>
//           <div>
//             <h2 className={styles.title}>All Selected Items</h2>
//             <p className={styles.subtitle}>
//               Your selected stock items ready for export
//               <span className={styles.matchInfo}>
//                 🟢 Green rows indicate Customer PKZ matches with your input
//               </span>
//             </p>
//           </div>
//           <div className={styles.headerButtons}>
//             <button onClick={onBack} className={styles.backButton}>
//               ← Back
//             </button>
//             <button onClick={exportToExcel} className={styles.exportButton}>
//               <span>📊</span>
//               Export to Excel
//             </button>
//           </div>
//         </div>

//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             {/* Table */}
//             <div className={styles.scrollContainer}>
//               <table className={styles.table}>
//                 <thead className={styles.tableHeader}>
//                   <tr>
//                     <th className={styles.th}>S.No</th>
//                     <th className={styles.th}>CAS</th>
//                     <th className={styles.thWide}>Description</th>
//                     <th className={styles.th}>Cat_No</th>
//                     <th className={styles.th}>PKZ</th>
//                     <th className={styles.th}>UOM</th>
//                     <th className={styles.th}>Customer PKZ</th>
//                     <th className={styles.th}>Stock In India</th>
//                     <th className={styles.th}>China Stock</th>
//                     <th className={styles.th}>HAZ / Non HAZ</th>
//                     <th className={styles.th}>Price</th>
//                     <th className={styles.th}>Discount</th>
//                     <th className={styles.th}>Final Price</th>
//                     <th className={styles.th}>Reference</th>
//                     <th className={styles.th}>Qty</th>
//                     <th className={styles.th}>Value</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {itemsWithDisplayNumbers.map((item) => (
//                     <tr 
//                       key={item.slno} 
//                       className={`${styles.tableRow} ${item.packSizeMatches ? styles.matchedRow : ''}`}
//                     >
//                       <td className={styles.tdCenter}>{item.displaySLNO}</td>
//                       <td className={styles.td}>{item.cas}</td>
//                       <td className={styles.tdWide}>{item.description}</td>
//                       <td className={styles.td}>{item.catNo}</td>
//                       <td className={styles.tdCenter}>{item.quantity}</td>
//                       <td className={styles.tdCenter}>{item.uom}</td>
//                       <td className={styles.tdCenter}>
//                         {item.packSize?.quantity ? (
//                           <span className={item.packSizeMatches ? styles.matchedText : ''}>
//                             {item.packSize.quantity}
//                             {item.packSizeMatches && <span className={styles.checkmark}> ✅</span>}
//                           </span>
//                         ) : (
//                           <span className={styles.emptyCell}>-</span>
//                         )}
//                       </td>
//                       <td className={styles.tdCenter}>{item.stockInIndia}</td>
//                       <td className={styles.tdCenter}>{item.chinaStock}</td>
//                       <td className={styles.tdCenter}>{item.hazStatus}</td>
//                       <td className={styles.tdRight}>{parseFloat(item.price).toFixed(2)}</td>
//                       <td className={styles.tdRight}>{item.discount}%</td>
//                       <td className={styles.tdRight}>{parseFloat(item.finalPrice).toFixed(2)}</td>
//                       <td className={styles.td}>{item.refNo}</td>
//                       <td className={styles.tdCenter}>{quantities[item.slno] || 0}</td>
//                       <td className={styles.tdRight}>{parseFloat(item.value).toFixed(2)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Footer */}
//             <div className={styles.footer}>
//               <div className={styles.footerStats}>
//                 Selected Items: <span className={styles.statValue}>{itemsWithDisplayNumbers.length}</span> |
//                 Customer PKZ Matches: <span className={styles.matchValue}>{pkzMatches}</span> |
//                 Total Value: <span className={styles.statValue}>{totalValue.toFixed(2)}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ThirdPage;


// src/pages/Dashboard/QuickQuote/components/ThirdPage.jsx
import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import styles from './ThirdPage.module.css';

const ThirdPage = ({ selectedData, quantities, onBack }) => {
  const [itemsWithDisplayNumbers, setItemsWithDisplayNumbers] = useState([]);

  useEffect(() => {
    // Add sequential display numbers to selected items
    const dataWithDisplayNumbers = selectedData.map((item, index) => ({
      ...item,
      displaySLNO: index + 1
    }));
    setItemsWithDisplayNumbers(dataWithDisplayNumbers);
  }, [selectedData]);

  const exportToExcel = () => {
    // Prepare data rows with proper number formatting
    const headers = [
      'S.No', 'CAS', 'Description', 'Cat_No', 'PKZ', 'UOM', 'Customer PKZ',
      'Stock In India', 'China Stock', 'HAZ / Non HAZ', 'Price',
      'Discount', 'Final Price', 'Reference', 'Qty', 'Value'
    ];

    const rows = itemsWithDisplayNumbers.map(item => {
      const pkz = item.packSize?.quantity ? item.packSize.quantity : '-';

      return [
        item.displaySLNO, // Number
        item.cas || '',
        item.description || '',
        item.catNo || '',
        item.quantity || '',
        item.uom || '',
        pkz,
        item.stockInIndia || '',
        item.chinaStock || '',
        item.hazStatus || '',
        parseFloat(item.price || 0), // Number
        parseFloat(item.discount || 0), // Number
        parseFloat(item.finalPrice || 0), // Number
        item.refNo || '',
        parseInt(quantities[item.slno] || 0), // Number
        parseFloat(item.value || 0) // Number
      ];
    });

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    
    // Define the range of cells in the worksheet
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    
    // Apply styling to all cells
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        
        if (!worksheet[cellRef]) {
          worksheet[cellRef] = { t: 's', v: '' };
        }
        
        // Header row styling (Row 0)
        if (R === 0) {
          worksheet[cellRef].s = {
            fill: {
              fgColor: { rgb: "4472C4" } // Professional blue
            },
            font: {
              name: "Calibri",
              sz: 12,
              bold: true,
              color: { rgb: "FFFFFF" } // White text
            },
            alignment: { 
              horizontal: "center", 
              vertical: "center",
              wrapText: true
            },
            border: {
              top: { style: "thin", color: { rgb: "FFFFFF" } },
              bottom: { style: "thin", color: { rgb: "FFFFFF" } },
              left: { style: "thin", color: { rgb: "FFFFFF" } },
              right: { style: "thin", color: { rgb: "FFFFFF" } }
            }
          };
        } 
        // Data rows styling
        else {
          const isEvenRow = R % 2 === 0;
          
          worksheet[cellRef].s = {
            fill: {
              fgColor: { rgb: isEvenRow ? "F2F2F2" : "FFFFFF" } // Alternating rows
            },
            font: {
              name: "Calibri",
              sz: 11,
              color: { rgb: "000000" }
            },
            alignment: { 
              horizontal: [0, 10, 11, 12, 14, 15].includes(C) ? "center" : 
                          [10, 11, 12, 15].includes(C) ? "right" : "left",
              vertical: "center",
              wrapText: C === 2 // Wrap text for Description column
            },
            border: {
              top: { style: "thin", color: { rgb: "D3D3D3" } },
              bottom: { style: "thin", color: { rgb: "D3D3D3" } },
              left: { style: "thin", color: { rgb: "D3D3D3" } },
              right: { style: "thin", color: { rgb: "D3D3D3" } }
            }
          };

          // Apply number format to numeric columns
          // Price (column 10), Final Price (column 12), Value (column 15)
          if ([10, 12, 15].includes(C)) {
            worksheet[cellRef].z = '#,##0.00'; // Number format with 2 decimals
            worksheet[cellRef].t = 'n'; // Ensure it's treated as number
          }
          
          // Discount (column 11)
          if (C === 11) {
            worksheet[cellRef].z = '0.00"%"'; // Percentage format
            worksheet[cellRef].t = 'n';
          }
          
          // Qty (column 14)
          if (C === 14) {
            worksheet[cellRef].z = '0'; // Whole number format
            worksheet[cellRef].t = 'n';
          }
          
          // S.No (column 0)
          if (C === 0) {
            worksheet[cellRef].t = 'n';
          }
        }
      }
    }

    // Set column widths
    const colWidths = [
      { wch: 6 },  // S.No
      { wch: 13 }, // CAS
      { wch: 45 }, // Description
      { wch: 13 }, // Cat_No
      { wch: 10 }, // PKZ
      { wch: 8 },  // UOM
      { wch: 13 }, // Customer PKZ
      { wch: 15 }, // Stock In India
      { wch: 13 }, // China Stock
      { wch: 15 }, // HAZ / Non HAZ
      { wch: 12 }, // Price
      { wch: 10 }, // Discount
      { wch: 13 }, // Final Price
      { wch: 13 }, // Reference
      { wch: 8 },  // Qty
      { wch: 13 }  // Value
    ];
    
    worksheet['!cols'] = colWidths;

    // Set row heights for better visibility
    worksheet['!rows'] = [
      { hpt: 30 }, // Header row height
      ...Array(rows.length).fill({ hpt: 20 }) // Data rows height
    ];

    // Add total row
    const totalRow = rows.length + 1;
    const totalValue = itemsWithDisplayNumbers.reduce((sum, item) => sum + item.value, 0);
    
    // Add "TOTAL" label
    const totalLabelCell = XLSX.utils.encode_cell({ r: totalRow, c: 14 });
    worksheet[totalLabelCell] = {
      t: 's',
      v: 'TOTAL:',
      s: {
        font: {
          name: "Calibri",
          sz: 11,
          bold: true,
          color: { rgb: "000000" }
        },
        alignment: { 
          horizontal: "right", 
          vertical: "center"
        },
        fill: {
          fgColor: { rgb: "FFE699" } // Light yellow
        },
        border: {
          top: { style: "medium", color: { rgb: "000000" } },
          bottom: { style: "medium", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "D3D3D3" } },
          right: { style: "thin", color: { rgb: "D3D3D3" } }
        }
      }
    };

    // Add total value
    const totalValueCell = XLSX.utils.encode_cell({ r: totalRow, c: 15 });
    worksheet[totalValueCell] = {
      t: 'n',
      v: totalValue,
      z: '#,##0.00',
      s: {
        font: {
          name: "Calibri",
          sz: 11,
          bold: true,
          color: { rgb: "000000" }
        },
        alignment: { 
          horizontal: "right", 
          vertical: "center"
        },
        fill: {
          fgColor: { rgb: "FFE699" } // Light yellow
        },
        border: {
          top: { style: "medium", color: { rgb: "000000" } },
          bottom: { style: "medium", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "D3D3D3" } },
          right: { style: "thin", color: { rgb: "D3D3D3" } }
        }
      }
    };

    // Update range to include total row
    worksheet['!ref'] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: totalRow, c: 15 }
    });

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Items");
    
    // Export the file
    const timestamp = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `quick_quote_${timestamp}.xlsx`, {
      bookType: 'xlsx',
      cellStyles: true
    });
  };

  const totalValue = itemsWithDisplayNumbers.reduce((sum, item) => sum + item.value, 0);
  const pkzMatches = itemsWithDisplayNumbers.filter(item => item.packSizeMatches).length;

  return (
    <div className={styles.pageContainer}>
      <div className={styles.card}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>All Selected Items</h2>
            <p className={styles.subtitle}>
              Your selected stock items ready for export
              <span className={styles.matchInfo}>
                🟢 Green rows indicate Customer PKZ matches with your input
              </span>
            </p>
          </div>
          <div className={styles.headerButtons}>
            <button onClick={onBack} className={styles.backButton}>
              ← Back
            </button>
            <button onClick={exportToExcel} className={styles.exportButton}>
              <span>📊</span>
              Export to Excel
            </button>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            {/* Table */}
            <div className={styles.scrollContainer}>
              <table className={styles.table}>
                <thead className={styles.tableHeader}>
                  <tr>
                    <th className={styles.th}>S.No</th>
                    <th className={styles.th}>CAS</th>
                    <th className={styles.thWide}>Description</th>
                    <th className={styles.th}>Cat_No</th>
                    <th className={styles.th}>PKZ</th>
                    <th className={styles.th}>UOM</th>
                    <th className={styles.th}>Customer PKZ</th>
                    <th className={styles.th}>Stock In India</th>
                    <th className={styles.th}>China Stock</th>
                    <th className={styles.th}>HAZ / Non HAZ</th>
                    <th className={styles.th}>Price</th>
                    <th className={styles.th}>Discount</th>
                    <th className={styles.th}>Final Price</th>
                    <th className={styles.th}>Reference</th>
                    <th className={styles.th}>Qty</th>
                    <th className={styles.th}>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsWithDisplayNumbers.map((item) => (
                    <tr 
                      key={item.slno} 
                      className={`${styles.tableRow} ${item.packSizeMatches ? styles.matchedRow : ''}`}
                    >
                      <td className={styles.tdCenter}>{item.displaySLNO}</td>
                      <td className={styles.td}>{item.cas}</td>
                      <td className={styles.tdWide}>{item.description}</td>
                      <td className={styles.td}>{item.catNo}</td>
                      <td className={styles.tdCenter}>{item.quantity}</td>
                      <td className={styles.tdCenter}>{item.uom}</td>
                      <td className={styles.tdCenter}>
                        {item.packSize?.quantity ? (
                          <span className={item.packSizeMatches ? styles.matchedText : ''}>
                            {item.packSize.quantity}
                            {item.packSizeMatches && <span className={styles.checkmark}> ✅</span>}
                          </span>
                        ) : (
                          <span className={styles.emptyCell}>-</span>
                        )}
                      </td>
                      <td className={styles.tdCenter}>{item.stockInIndia}</td>
                      <td className={styles.tdCenter}>{item.chinaStock}</td>
                      <td className={styles.tdCenter}>{item.hazStatus}</td>
                      <td className={styles.tdRight}>{parseFloat(item.price).toFixed(2)}</td>
                      <td className={styles.tdRight}>{item.discount}%</td>
                      <td className={styles.tdRight}>{parseFloat(item.finalPrice).toFixed(2)}</td>
                      <td className={styles.td}>{item.refNo}</td>
                      <td className={styles.tdCenter}>{quantities[item.slno] || 0}</td>
                      <td className={styles.tdRight}>{parseFloat(item.value).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
              <div className={styles.footerStats}>
                Selected Items: <span className={styles.statValue}>{itemsWithDisplayNumbers.length}</span> |
                Customer PKZ Matches: <span className={styles.matchValue}>{pkzMatches}</span> |
                Total Value: <span className={styles.statValue}>{totalValue.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdPage;